module.exports = __webpack_public_path__ + "img/Skirt-Front-B9-Da-Ha-Ic-Ja.d24bfc3f.png";